// @owners { team: patients }
import { ActionSheetContext, Body, Button, Card, ListItem, Separator, SmSpacing, Tag } from '@alto/design-system';
import { MedImage, Pill, RenewalRequestActionSheet } from '@alto/features';
import React, { Fragment, useContext } from 'react';
import { formatQuantity } from '~shared/helpers/helper';
import { type Prescription } from '~shared/types';

type Props = {
  prescriptions: Prescription[];
};

export const LastRefillCard = ({ prescriptions }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  return (
    <Card
      title="Last refill"
      description="Request more so you don't run out"
    >
      {prescriptions.map((prescription, index) => {
        return (
          <Fragment key={prescription.id}>
            {index !== 0 && <Separator />}
            <ListItem
              verticalAlignment="top"
              LeftContent={
                prescription.image_url ? (
                  <MedImage
                    imageUrl={prescription.image_url}
                    clickable={false}
                  />
                ) : (
                  <Pill />
                )
              }
              title={prescription.medication_name}
              tags={prescription.active_renewal_request_start_at ? <Tag label="Refills requested" /> : undefined}
              descriptions={<Body textSize="detail">{formatQuantity(prescription)}</Body>}
              BottomButton={
                prescription.active_renewal_request_start_at ? undefined : (
                  <Button
                    type="primary"
                    width="inline"
                    onPress={() => {
                      setActiveActionSheet(<RenewalRequestActionSheet prescriptionIDs={[prescription.id]} />);
                    }}
                    small
                  >
                    Get more refills
                  </Button>
                )
              }
            />
          </Fragment>
        );
      })}
      <SmSpacing />
    </Card>
  );
};
